import { useState } from "react";
import { toast } from "sonner";
import { useStars, STARS } from "../lib/stars";
import { Bini } from "./Bini";
import { t } from "../i18n";

export const StarShape = ({ color = "#FFD21F", className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17l-6.1 3.4 1.5-6.8L2.2 9l6.9-.7z" fill={color} stroke="#fff" strokeWidth="1.2" strokeLinejoin="round" />
  </svg>
);

// A small star to discover; once tapped it flies to Bini's sky and stays found on this device
export const HiddenStar = ({ id, className = "" }) => {
  const { found, collect } = useStars();
  const [popping, setPopping] = useState(false);
  if (found.includes(id) && !popping) return null;
  const color = STARS.find((s) => s.id === id)?.color;

  const onTap = () => {
    setPopping(true);
    collect(id);
    toast(t("stars.found"), { icon: <Bini size={28} />, duration: 2500 });
    setTimeout(() => setPopping(false), 600);
  };

  return (
    <button type="button" onClick={onTap} data-testid={`hidden-star-${id}`} aria-label={t("stars.hiddenLabel")}
      className={`hidden-star absolute z-20 grid h-12 w-12 place-items-center ${popping ? "star-pop" : "anim-wiggle"} ${className}`}>
      <StarShape color={color} className="h-7 w-7 opacity-90 drop-shadow" />
    </button>
  );
};
